module.exports = __webpack_public_path__ + "static/ARTS_LOGO_Yatay-6a3f145f8995e3c9bea3498cb550935b.png";